import { Checkbox, HoverIcon } from "../..";

export interface RowSelectorProps {
  checked?: boolean;
  onCheckedChange?: () => void;
  showCheckbox?: boolean;
  showHoverIcon?: boolean;
  onHoverIconClick?: () => void;
  isHovered?: boolean;
  className?: string;
  hoverIconPosition?: {
    top?: string;
    left?: string;
  };
  hoverIconRelativeToParent?: boolean;
}

export function RowSelector({
  checked = false,
  onCheckedChange,
  showCheckbox = true,
  showHoverIcon = true,
  onHoverIconClick,
  isHovered = false,
  className = "",
  hoverIconPosition = { left: "8px" },
  hoverIconRelativeToParent = false,
}: RowSelectorProps) {
  return (
    <>
      <div className={`flex justify-center ${!hoverIconRelativeToParent ? "relative" : ""} ${className}`}>
        {showCheckbox && (
          <Checkbox checked={checked} onCheckedChange={onCheckedChange} onClick={(e) => e.stopPropagation()} />
        )}
        {showHoverIcon && isHovered && onHoverIconClick && !hoverIconRelativeToParent && (
          <HoverIcon onClick={onHoverIconClick} position={hoverIconPosition} />
        )}
      </div>
      {showHoverIcon && isHovered && onHoverIconClick && hoverIconRelativeToParent && (
        <HoverIcon onClick={onHoverIconClick} position={hoverIconPosition} />
      )}
    </>
  );
}
